import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";
import { Preview, print } from "react-html2pdf";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { alertTitleClasses } from "@mui/material";

export class ExternalTestsSelect extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    var values = [];
    var submitArray = [];
    this.state = {
      chiefComplaint: "",
      historyofPresentIllness: "",
      physicalGeneral: "",
      obstetricGynecologicalExam: "",
      // diagnosis: "",
      plan: "",
      treatment: "",

      options: {},
      diagnosis: [],
      bloodglucoserbs: "",
      bloodglucosefbs: "",
      bloodglucosehba1: "",
      livergot: "",
      livergpt: "",
      livertotalbilr: "",
      liverdirectbilr: "",
      liveralkphos: "",
      liverggt: "",
      livertotalprotein: "",
      liveralbumin: "",
      lipidcholesterol: "",
      lipidtriglyceride: "",
      lipidhdl: "",
      lipidldl: "",
      renalcreatinine: "",
      renalurea: "",
      renalsodium: "",
      renalpotassium: "",
      renalcalcium: "",
      renalchloride: "",
      renalphosphorus: "",
      malaria: "",
      uriappearance: "",
      uriph: "",
      uriprotein: "",
      uriglucose: "",
      uribilirubin: "",
      sedwbc: "",
      sedrbc: "",
      sede2cells: "",
      sedcasts: "",
      sedothers: "",
      pregnancy: "",
      stoolappearance: "",
      stoolconsistency: "",
      stoolmicroscopy: "",
      diagnosticstudies: "",
      seraso: "",
      serwidal: "",
      serhpylori: "",
      serbrucella: "",
      serrf: "",
      sercrp: "",
      serrprvdrl: "",
      serrvi: "",
      sertpha: "",
      serpsa: "",
      serhbsag: "",
      serhcv: "",
      sertoxopla: "",
      seresr: "",
      serhb: "",
      serhct: "",
      serwbc: "",
      serdc: "",
      sern: "",
      serl: "",
      serm: "",
      sere: "",
      serb: "",

      FBS: "",
      RBS: "",
      HbA1: "",
      GOT: "",
      GPT: "",
      TOTALBILR: "",
      DIRECBILR: "",
      ALKPHOS: "",

      GGT: "",
      TOTALPROTEIN: "",
      ALBUMIN: "",
      CHOLESTEROL: "",
      TRIGLYCERIDE: "",
      HDL: "",
      LDL: "",
      CREATININE: "",
      UREA: "",
      SODIUM: "",
      POTASSIUM: "",
      CALCIUM: "",
      CHLORIDE: "",
      PHOSPHORUS: "",

      URICACID: "",
      T3total: "",
      T4f: "",
      TSH: "",
      PT: "",
      PTT: "",
      APTT: "",

      Hb: "",
      HCT: "",
      WBC: "",
      DC: "",
      N: "",
      L: "",
      M: "",
      E: "",
      B: "",
      Malaria: "",

      Appearance: "",
      PH: "",
      Protein: "",
      Glucose: "",
      Bilirubin: "",

      WBC: "",
      RBC: "",
      E_Cells: "",
      Casts: "",
      Sedimentation: "",

      Pregnancy: "",
      Appearance: "",
      Consistency: "",
      Microscopy: "",
      DIAGNOSTIC_STUDIES: "",

      patientName: localStorage.getItem("currentVisitName"),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);

    let tablevalues = this.componentDidMount(submitArray);

    // this.handleMultiChange = this.handleMultiChange.bind(this);
  }

  componentDidMount(submitArray) {
    //   console.log(localStorage.getItem('externallabtests'))
    var finalArray = [];
    $("body").on("change", "input", ".fieldName", function (event) {
      var value = $(this).val();

      var name = $(this).attr("name");
      var dict = {
        [name]: value,
      };

      //   console.log(dict)
      finalArray.push(dict);
      //   console.log(finalArray)
    });

    submitArray = finalArray;

    $(".testsSubmitted").on("submit", function (e) {
      e.preventDefault();
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("accessToken"),
        visitid: localStorage.getItem("currentVisitId"),
      };

      console.log(submitArray);

      for (var i = 0; i < submitArray.length; i++) {
        var name = Object.keys(submitArray[i]);
        var newDict = {
          [name]: submitArray[i][Object.keys(submitArray[i])],
        };
        // console.log(newDict)
        axios
          .get(this.api_url+"laboratory/tests", newDict, {
            headers: headers,
          })
          .then((response) => {
            // console.log(response)

            if (response.data["status"]) {
              $("#loginSuccess").show();
              // setTimeout(function () {
              //     //
              //     $('.checkHistory').click()
              // }, 1500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });

    var externaltests = localStorage.getItem("externallabtests").split(",");
    console.log(externaltests[0]);
    for (var i = 0; i < externaltests.length; i++) {
      var div =
        '<div className="py-1"><h6 className="text-capitalize" style={fontFamilyNunito}>' +
        externaltests[i] +
        '</h6><input className="form-control fieldName" onChange="' +
        this.handleChange +
        '" value="" name="' +
        externaltests[i] +
        '" type="text" required /> </div>';

      $(".testsToBeDone").append(div);
    }

    //    console.log(div)
  }

  formatTableOutput(data) {
    // let topobj = {};
    // let tableobj = {};
    // for (let i = 0; i < data.length; i++) {
    //     let trim = data[i];
    //     let trimobj = {};
    //     trimobj.ExamDate = data[i][0];
    //     trimobj.ExamType = data[i][1];
    //     trimobj.Result = data[i][2];
    //     tableobj[i] = trimobj;
    //     topobj.prepplan = tableobj;
    // }
    // this.state.tablevaluesglobal = topobj['prepplan'];
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  onTableChange(event) {}

  proceedEvent(event) {
    window.location.href = "/triage/admission/triage";
  }

  handleSubmit(submitArray) {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    // event.preventDefault();

    console.log(submitArray);

    axios
      .post(this.api_url+"laboratory/tests", this.state, {
        headers: headers,
      })
      .then((response) => {
        // console.log(response)

        if (response.data["status"]) {
          $("#loginSuccess").show();
          setTimeout(function () {
            //
            $(".checkHistory").click();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.Route = data[i][0];
      trimobj.DrugName = data[i][1];
      trimobj.Dosage = data[i][2];
      trimobj.Frequency = data[i][3];
      trimobj.Duration = data[i][4];
      trimobj.DrugAdministration = data[i][6];
      trimobj.midwifenursename = data[i][7];
      trimobj.remarks = data[i][8];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
  }

  handleTableChange(event) {}

  getTableValues(event) {
    var data = event;
    let topobj = {};
    let tableobj = {};
    // console.log(event.length)
    // var data = event.
    // for (let i = 0; i < data.length; i++) {
    //     let trim = data[i];
    let trimobj = {};
    this.setState({
      Year: "1212",
    });
    console.log(data[0]);
    trimobj.Route = data[0][0];
    trimobj.DrugName = data[0][1];
    trimobj.Dosage = data[0][2];
    trimobj.Frequency = data[0][3];
    trimobj.Duration = data[0][4];
    trimobj.DrugAdministration = data[0][5];
    trimobj.midwifenursename = data[0][6];
    trimobj.remarks = data[0][7];

    tableobj = trimobj;
    topobj.prepplan = tableobj;
    // }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
    // let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [["", "", "", "", "", "", "", ""]];

    const columns = [
      "Sn",
      "Route",
      "Drug Name",
      "Dosage",
      "Frequency",
      "Duration",
      "Doctor`s Remarks",
      "Name of Doctor",
    ];

    const font16 = { fontSize: "22px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      diagnosis,
      options,
      patientName,
      bloodglucoserbs,
      bloodglucosefbs,
      bloodglucosehba1,
      livergot,
      livergpt,
      livertotalbilr,
      liverdirectbilr,
      liveralkphos,
      liverggt,
      livertotalprotein,
      liveralbumin,
      lipidcholesterol,
      lipidtriglyceride,
      lipidhdl,
      lipidldl,
      renalcreatinine,
      renalurea,
      renalsodium,
      renalpotassium,
      renalcalcium,
      renalchloride,
      renalphosphorus,
      malaria,
      uriappearance,
      uriph,
      uriprotein,
      uriglucose,
      uribilirubin,
      sedwbc,
      sedrbc,
      sede2cells,
      sedcasts,
      sedothers,
      pregnancy,
      stoolappearance,
      stoolconsistency,
      stoolmicroscopy,
      diagnosticstudies,
      seraso,
      serwidal,
      serhpylori,
      serbrucella,
      serrf,
      sercrp,
      serrprvdrl,
      serrvi,
      sertpha,
      serpsa,
      serhbsag,
      serhcv,
      sertoxopla,
      seresr,
      serhb,
      serhct,
      serwbc,
      serdc,
      sern,
      serl,
      serm,
      sere,
      serb,
      FBS,
      RBS,
      HbA1,
      GOT,
      GPT,
      TOTALBILR,
      DIRECBILR,
      ALKPHOS,

      GGT,
      TOTALPROTEIN,
      ALBUMIN,
      CHOLESTEROL,
      TRIGLYCERIDE,
      HDL,
      LDL,
      CREATININE,
      UREA,
      SODIUM,
      POTASSIUM,
      CALCIUM,
      CHLORIDE,
      PHOSPHORUS,

      URICACID,
      T3total,
      T4f,
      TSH,
      PT,
      PTT,
      APTT,

      Hb,
      HCT,
      WBC,
      DC,
      N,
      L,
      M,
      E,
      B,
      Malaria,

      PH,
      Protein,
      Glucose,
      Bilirubin,

      RBC,
      E_Cells,
      Casts,
      Sedimentation,

      Pregnancy,
      Appearance,
      Consistency,
      Microscopy,
      DIAGNOSTIC_STUDIES,
    } = this.state;

    return (
      <div>
        <Headers />
        <InterModularSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form className="testsSubmitted">
              <h6 className="text-capitalize" style={fontFamilyNunito}>
                {" "}
                Tests to be done
              </h6>
              <div className="form-row pt-4 testsToBeDone">=</div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default ExternalTestsSelect;
